import { useState, useRef } from "react";
import { Volume2, Square, Loader2 } from "lucide-react";
import { api, absoluteUrl } from "../lib/api";
import { useLang } from "../i18n/LanguageContext";

// Tekrar kullanilabilir "Tudi sesli anlatsin" butonu
export function SpeakButton({ getText, label, testid = "speak-button", light = false }) {
  const { lang } = useLang();
  const audioRef = useRef(null);
  const [speaking, setSpeaking] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggle = async () => {
    if (speaking) {
      audioRef.current?.pause();
      setSpeaking(false);
      return;
    }
    try {
      setLoading(true);
      const text = typeof getText === "function" ? getText() : getText;
      const r = await api.post("/tts", { text, lang });
      const a = new Audio(absoluteUrl(r.data.url));
      audioRef.current = a;
      a.onended = () => setSpeaking(false);
      await a.play();
      setSpeaking(true);
    } catch { /* sessiz geç */ } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={toggle}
      data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full font-semibold text-sm px-5 py-2.5 transition-colors border ${
        light ? "bg-white/15 border-white/25 text-white hover:bg-white/25" : "bg-white border-brand/30 text-brand hover:bg-brand/5"
      }`}
    >
      {loading ? <Loader2 size={15} className="animate-spin" /> : speaking ? <Square size={15} /> : <Volume2 size={15} />}
      {label}
    </button>
  );
}
